var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg002SettingLines(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 456.6 456.6",
    style: {
      enableBackground: "new 0 0 456.6 456.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FF6C37;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M97.6,79.4H13.4C6,79.4,0,73.4,0,66s6-13.4,13.4-13.4h84.1c7.4,0,13.4,6,13.4,13.4S105,79.4,97.6,79.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M145.6,127.5c-33.9,0-61.5-27.6-61.5-61.5c0-33.9,27.6-61.5,61.5-61.5s61.5,27.6,61.5,61.5 C207.1,99.9,179.6,127.5,145.6,127.5z M145.6,31.4C126.5,31.4,111,46.9,111,66s15.5,34.6,34.7,34.6s34.7-15.5,34.7-34.6 S164.8,31.4,145.6,31.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M443.1,79.4H242.4c-7.4,0-13.4-6-13.4-13.4s6-13.4,13.4-13.4h200.7c7.4,0,13.4,6,13.4,13.4 S450.5,79.4,443.1,79.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M325.9,289.8c-33.9,0-61.5-27.6-61.5-61.5s27.6-61.5,61.5-61.5s61.5,27.6,61.5,61.5S359.9,289.8,325.9,289.8z  M325.9,193.6c-19.1,0-34.7,15.5-34.7,34.6s15.5,34.6,34.7,34.6s34.7-15.5,34.7-34.6S345,193.6,325.9,193.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M229.1,241.7H13.4c-7.4,0-13.4-6-13.4-13.4s6-13.4,13.4-13.4h215.7c7.4,0,13.4,6,13.4,13.4 S236.6,241.7,229.1,241.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M443.1,241.7H374c-7.4,0-13.4-6-13.4-13.4s6-13.4,13.4-13.4h69.1c7.4,0,13.4,6,13.4,13.4 S450.5,241.7,443.1,241.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M130.6,452.1c-33.9,0-61.5-27.6-61.5-61.5c0-33.9,27.6-61.5,61.5-61.5s61.5,27.6,61.5,61.5 C192.1,424.5,164.5,452.1,130.6,452.1z M130.6,355.9c-19.1,0-34.7,15.5-34.7,34.6s15.5,34.7,34.7,34.7s34.7-15.5,34.7-34.7 S149.7,355.9,130.6,355.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M443.1,404H227.4c-7.4,0-13.4-6-13.4-13.4s6-13.4,13.4-13.4h215.7c7.4,0,13.4,6,13.4,13.4S450.5,404,443.1,404 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M82.5,404H13.4C6,404,0,398,0,390.5c0-7.4,6-13.4,13.4-13.4h69.1c7.4,0,13.4,6,13.4,13.4 C96,398,90,404,82.5,404z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg002SettingLines);
export default __webpack_public_path__ + "static/media/002-setting-lines.e0abd27164259675254205763cbfb8cf.svg";
export { ForwardRef as ReactComponent };